import { __rest } from 'tslib';
import React from 'react';
import { PeekTextField } from './PeekTextField.js';
import { styled } from '@mui/material/styles';
import { InputAdornment } from '@mui/material';
import { AlertCircle, Check } from '@piiqtechnologies/svg-icons';

const ErrorIcon = styled(AlertCircle)(({ theme }) => (Object.assign({ color: theme.palette.error.main }, theme.typography.h4)));
const ValidIcon = styled(Check)(({ theme }) => (Object.assign({ color: theme.palette.success.main }, theme.typography.h4)));
const resolvePath = (object, path, defaultValue) => path
    .split(/[\.\[\]\'\"]/)
    .filter((p) => p)
    .reduce((o, p) => (o ? o[p] : defaultValue), object);
const PeekInput = (_a) => {
    var { field, form, required, horizontalLabel, minWidthLabel, InputProps = {} } = _a, props = __rest(_a, ["field", "form", "required", "horizontalLabel", "minWidthLabel", "InputProps"]);
    const { name } = field;
    const fieldTouched = resolvePath(form.touched, name);
    const fieldError = resolvePath(form.errors, name);
    const error = fieldTouched && Boolean(fieldError);
    const errorText = fieldTouched && fieldError;
    const valid = fieldTouched && !Boolean(fieldError);
    return (React.createElement(PeekTextField, Object.assign({ valid: valid, horizontalLabel: horizontalLabel, minWidthLabel: minWidthLabel, variant: "standard", InputLabelProps: { required: required, shrink: true }, InputProps: Object.assign({ disableUnderline: true, endAdornment: (React.createElement(InputAdornment, { sx: { width: 20 }, position: "start" },
                error && React.createElement(ErrorIcon, null),
                valid && React.createElement(ValidIcon, null))) }, InputProps), error: error, helperText: errorText }, field, props)));
};

export { PeekInput, PeekInput as default, resolvePath };
